/* Copyright (c) 2021 MOCA Systems, Inc.	All rights reserved. */

import { Component, OnInit, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SwUpdate } from '@angular/service-worker';
import * as appStrings from '@touchplan/strings';

@Component({
	selector: 'app-force-refresh-dialog',
	templateUrl: './force-refresh-dialog.component.html',
	styleUrls: ['./force-refresh-dialog.component.scss'],
})
export class ForceRefreshDialogComponent implements OnInit {
	public strings = appStrings;

	public webWorkerBackgroundLoadingDone: Promise<boolean>;

	constructor(
		public dialogRef: MatDialogRef<ForceRefreshDialogComponent>,
		@Optional() private sw: SwUpdate
	) {}

	public ngOnInit() {
		this.webWorkerBackgroundLoadingDone = this.checkForBackgroundRefresh();
	}

	private checkForBackgroundRefresh() {
		//no service workers on desktop
		if (this.sw && this.sw.isEnabled) {
			return this.sw.checkForUpdate();
		} else {
			return Promise.resolve(false); //checkForUpdate returns false when there's nothing to update, this is... close enough
		}
	}

	public onClick(): void {
		this.dialogRef.close();
	}
}
